import * as React from 'react'
import { ReactComponent as ShareIcon } from 'assets/share.svg'
import { styled } from 'styled-components'
import { Props } from './types'
import { useModal } from 'modules/ui'
import theme from 'theme'
import useTranslations from 'hooks/useTranslations'
import ModalContent from './ModalContent'
import { pushTrackingEvent } from './utils'
import config from 'config'

export default function Share(props: Props) {
  const t = useTranslations<'molecules-Share'>()
  const modal = useModal()
  const [showModal, setShowModal] = React.useState(false)
  const prevFocusEl = React.useRef<HTMLElement | null>(null)
  const defaultLinkToShare =
    typeof window !== `undefined` ? window.location.href : ''

  let linkToShare
  if (props.linkToShare) {
    if (props.internalLink) {
      if (process.env.NODE_ENV === 'development')
        linkToShare = window.location.origin + props.linkToShare
      else
        linkToShare =
          window.location.origin + '/' + config.locale + props.linkToShare
    } else linkToShare = props.linkToShare
  } else linkToShare = defaultLinkToShare

  const buttonType = props.buttonType ? props.buttonType : 'symbol'

  const openShareModal = () => {
    prevFocusEl.current = document.activeElement as HTMLElement
    setShowModal(true)
    modal.setContent(
      <ModalContent
        productName={props.productName}
        linkToShare={linkToShare}
        onCloseClick={() => {
          modal.setContent(null)
          setShowModal(false)
        }}
      />
    )
    pushTrackingEvent('open-dialog')
  }

  React.useEffect(() => {
    if (modal.content === null) {
      prevFocusEl.current?.focus()
    }
  }, [showModal])

  return (
    <Wrapper
      className="Share"
      data-cy-ctx="molecules/Share"
      $buttonType={buttonType}
      onClick={openShareModal}
      onKeyDown={(e) => {
        if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault()
          openShareModal()
        }
      }}
      aria-label="share product" // TODO: bfsg snippet
    >
      <ShareIcon className="share_icon" />{' '}
      {buttonType === 'symbol_and_text' ? (
        <p
          className="share_button_label"
          data-cy-state="symbol-and-text-button-active"
        >
          {t('share_button_label')}
        </p>
      ) : null}
    </Wrapper>
  )
}

const Wrapper = styled.button<{ $buttonType: string }>`
  display: flex;
  align-items: center;
  justify-content: center;

  > .share_icon {
    height: 1.25rem;
    width: 1.5625rem;
    ${(props) => {
      return props.$buttonType === 'symbol' ? 'transform: scale(1.4)' : ''
    }};
    > path {
      fill: ${theme.colors.b0};
    }
  }

  > .share_button_label {
    ${theme.ty('rc-base', 'bold')};
    margin-bottom: 0;
    margin-top: 0;
    text-decoration: underline;
  }
`
